module.exports = __webpack_public_path__ + "static/favicon-a7789fdea0499abaa3cbbd800d882925.png";